export enum ClaimTypes {
  CELLPHONE = 'CELLPHONE',
  EMAIL = 'EMAIL',
}
